var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.85,
    height: 19.85,
    viewBox: "0 0 19.85 19.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    transform: "translate(0.8 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-edit-2",
    "data-name": "Icon material-edit",
    transform: "translate(-4.5 -4.496)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,18.944v3.8H8.3L19.513,11.534l-3.8-3.8ZM22.453,8.594a1.01,1.01,0,0,0,0-1.429L20.081,4.793a1.01,1.01,0,0,0-1.429,0L16.8,6.648l3.8,3.8,1.855-1.855Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.301507949829102 22.74600791931152 L 19.51340866088867 11.53409862518311 L 15.71189785003662 7.732598781585693 L 4.499998092651367 18.94449806213379 L 4.499998092651367 22.74600791931152 L 8.301507949829102 22.74600791931152 M 20.59810829162598 10.44940853118896 L 22.45323753356934 8.594268798828125 C 22.84859848022461 8.198918342590332 22.84859848022461 7.560268878936768 22.45323753356934 7.164908885955811 L 20.08109855651855 4.792768478393555 C 19.68574523925781 4.397407054901123 19.04708480834961 4.397409915924072 18.6517391204834 4.792768478393555 L 16.79659843444824 6.64789867401123 L 20.59810829162598 10.44940853118896 M 8.632878303527832 23.5460090637207 L 3.699998378753662 23.5460090637207 L 3.699998378753662 18.61312866210938 L 18.08605766296387 4.227078914642334 C 18.42836761474609 3.884768724441528 18.88307762145996 3.696248769760132 19.36641883850098 3.696248769760132 C 19.84977912902832 3.696248769760132 20.30448913574219 3.884778738021851 20.64679908752441 4.22709846496582 L 23.01892852783203 6.599218845367432 C 23.36123847961426 6.94153881072998 23.54975891113281 7.396248817443848 23.54975891113281 7.879588603973389 C 23.54975891113281 8.36293888092041 23.36123847961426 8.817648887634277 23.01891899108887 9.159958839416504 L 8.632878303527832 23.5460090637207 Z",
    stroke: "none",
    fill: "#000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.27760493bc5420b96f27c55f5d61b1f8.svg";
export { ForwardRef as ReactComponent };